<template>
  <div style="width: 100%;height: 100%;background-color: white">
    <div style="height: 20px"></div>
    <div style="height: calc(100% - 20px);margin: 0 20px;overflow-y: auto">
      <div style="height: 50px">
        <el-radio-group v-model="pssType" @change="changePage">
          <el-radio-button :label="1">单次</el-radio-button>
          <el-radio-button :label="2">循环</el-radio-button>
        </el-radio-group>
        <el-button type="primary" plain @click="addServiceOrderBtn()">发起服务单</el-button>
        <el-date-picker v-fixZoom v-model="sendTime" type="daterange" range-separator="至"
          start-placeholder="开始日期" end-placeholder="结束日期" style="width: 230px" value-format="yyyy-MM-dd" clearable>
        </el-date-picker>
        <el-select v-fixZoom multiple collapse-tags v-model="so_ids" placeholder="请选择服务商" style="width: 200px" clearable>
          <el-option v-for="item in allSupplier" :key="item.id" :label="item.name" :value="item.id">
          </el-option>
        </el-select>
        <el-cascader v-fixZoom style="width: 200px" :options="typeTree" v-model="st_id" :filterable="true" placeholder="请选择服务内容" clearable
                     :props="{ checkStrictly: true, value: 'id', label: 'typename', children: 'child', emitPath: false, disabled: 'isService'}" ref="typeOptions" @change="changeType">
          <template #default="{data}">
            <span v-if="data.is_service !== 1" style="font-style: italic;color: #999999">{{ data.typename}}</span><strong v-else style="color: #1a1a1a;">{{ data.typename}}</strong>
          </template>
        </el-cascader>
        <el-input placeholder="服务人员" v-model="searchKeyword" style="width: 160px" clearable></el-input>
        <el-input placeholder="服务对象" v-model="oldperson_name" style="width: 160px" clearable></el-input>
        <el-button type="primary" @click="searchQuery">查询</el-button>
      </div>
      <div style="max-height: calc(100% - 100px);overflow-y: auto">
        <el-table v-loading="loading" element-loading-text="加载中，请耐心等待。" :data="tableData" border style="width: 100%" highlight-current-row ref="singleTable">
          <el-table-column
            type="index"
            label="序号"
            width="70"
            align="center">
          </el-table-column>
          <el-table-column
            label="发起类型"
            min-width="60"
            align="center">
            <template slot-scope="scope">
              <button v-if="scope.row.service_from === 1 || scope.row.service_from === 0" class="blue-tab">客服</button>
              <button v-if="scope.row.service_from === 2" class="purple-tab">循环单</button>
              <button v-if="scope.row.service_from === 3" class="yellow-tab">家人</button>
              <button v-if="scope.row.service_from === 4" class="pink-tab">老人</button>
              <button v-if="scope.row.service_from === 5" class="green-tab">服务商护工</button>
            </template>
          </el-table-column>
          <el-table-column
            label="订单号"
            min-width="70"
            align="center">
            <template slot-scope="scope">
              <span>{{scope.row.orderid}}</span>
            </template>
          </el-table-column>
          <el-table-column
            label="服务对象"
            min-width="110"
            align="center">
            <template slot-scope="scope">
              <span>{{scope.row.person_name}}</span>
            </template>
          </el-table-column>
          <el-table-column
            label="服务内容"
            min-width="110"
            align="center">
            <template slot-scope="scope">
              <span>{{scope.row.supplier_type_name }}</span>
            </template>
          </el-table-column>
          <el-table-column
            v-if="pssType === 2"
            label="服务频率"
            min-width="100"
            align="center">
            <template slot-scope="scope">
              <span>{{getFrequencyName(scope.row)}}</span>
            </template>
          </el-table-column>
          <el-table-column
            label="服务提供商"
            min-width="100"
            align="left">
            <template slot-scope="scope">
              <el-tag size="mini" v-if="scope.row.grab_tag === '01' || scope.row.grab_tag === '11'" type="warning">抢单</el-tag>
              <el-tag size="mini" v-else type="success">指派</el-tag>
              <span>{{scope.row.supplier_name}}</span>
            </template>
          </el-table-column>
          <el-table-column
            label="服务人员"
            min-width="100"
            align="left">
            <template slot-scope="scope">
              <el-tag size="mini" v-if="scope.row.grab_tag === '01' || scope.row.grab_tag === '11'" type="warning">抢单</el-tag>
              <el-tag size="mini" v-else type="success">指派</el-tag>
              <span>{{scope.row.supplier_person_name}}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="begin_time"
            label="开始时间"
            min-width="110"
            align="center">
          </el-table-column>
          <el-table-column
            prop="end_time"
            label="结束时间"
            min-width="110"
            align="center">
          </el-table-column>
          <el-table-column
            v-if="pssType === 2"
            prop="next_time"
            label="派单时间"
            min-width="110"
            align="center">
          </el-table-column>
          <el-table-column align="center" label="操作" width="240">
            <template slot-scope="scope">
              <el-button size="mini" type="primary" plain @click="updateService(scope.row)">修改服务单</el-button>
              <el-button size="mini" type="warning" plain @click="handleService(scope.row)">服务单详情</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div style="margin-top: 10px;height: 40px;text-align: center">
        <el-pagination v-fixZoom @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage"
          :page-sizes="[10, 20, 50, 100]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper" :total="totalCells">
        </el-pagination>
      </div>
    </div>
    <!--新增服务单-->
    <el-dialog :visible.sync="addServiceOrderShow" v-if="addServiceOrderShow"
               width="900px" :show-close="true" :close-on-click-modal="false" center class="all-open">
      <div class="title-top-alarm">
        <div>{{titleShow}}</div>
        <div class="line-title"></div>
      </div>
      <add-service-order :addObj="addObj" v-model="addServiceOrderShow" @changeUpadte="getTableOrder"></add-service-order>
    </el-dialog>
  </div>
</template>

<script>
import addServiceOrder from './childComponents/addServiceOrder'
import {
  querysupplierorgnotype,
  querysuppliertype,
  querypersonsupplierservice
} from '../../api/serviceMark'
import {queryorg} from '../../api/organizer'
import {queryfrequency} from '../../api/serviceObject'
export default {
  name: 'serviceOrder',
  components: {addServiceOrder},
  data () {
    return {
      loading: false,
      searchKeyword: '',
      oldperson_name: '',
      pssType: 1,
      sendTime: null,
      so_ids: [],
      st_id: '',
      typeTree: [],
      pageSize: 10,
      currentPage: 1,
      totalCells: 0,
      tableData: [],
      allSupplier: [], // 服务商
      allService: [], // 服务商服务内容
      frequencys: [], // 服务频率
      titleShow: '',
      addServiceOrderShow: false,
      addObj: {
        isAdd: 1,
        pssType: 1,
        row: '',
        types: [],
        treeData: [],
        frequencys: []
      }
    }
  },
  created () {
    this.getOrgData()
  },
  methods: {
    // 切换页面展示
    changePage () {
      this.totalCells = 0
      this.pageSize = 10
      this.tableData = []
      this.getTableOrder()
      this.addObj.pssType = this.pssType
    },
    // 组织
    getOrgData () {
      this.loading = true
      queryorg().then(res => {
        this.addObj.treeData = res.data.org
        this.getFrequency()
      }).catch(() => {
        this.loading = false
      })
    },
    // 服务频率
    getFrequency () {
      this.loading = true
      let data = {
        orgid: this.$store.state.user.orgid
      }
      queryfrequency(data).then(res => {
        this.frequencys = res.data.frequencys
        this.addObj.frequencys = res.data.frequencys
        this.querySupplierTypeData()
      }).catch(() => {
        this.loading = false
      })
    },
    getFrequencyName (row) {
      for (let i = 0; i < this.frequencys.length; i++) {
        if (row.frequency_id === this.frequencys[i].id) {
          return this.frequencys[i].frequency
        }
      }
    },
    // 服务类型
    querySupplierTypeData () {
      this.loading = true
      let params = {
        page: 1,
        size: 99999
      }
      let data = {
        orgid: []
      }
      querysuppliertype(params, data).then(res => {
        this.addObj.types = res.data.types
        this.getTypeTree()
        this.getAllSupplier()
      }).catch(() => {
        this.loading = false
      })
    },
    getTypeTree () {
      let lastLevel = 100
      const arr = this.clone(this.addObj.types)
      for (let i = 0; i < arr.length; i++) {
        arr[i].isService = false
        if (arr[i].is_service === 0) {
          arr[i].isService = true
        }
        if (arr[i].level < lastLevel) {
          lastLevel = arr[i].level
        }
      }
      for (let i = 0; i < arr.length; i++) {
        if (arr[i].level === lastLevel) {
          this.typeTree.push(arr[i])
        }
      }
      for (let i = 0; i < this.typeTree.length; i++) {
        const child = this.arrayToNode1(arr, this.typeTree[i].id)
        if (child.length !== 0) {
          this.typeTree[i].child = child
        }
      }
    },
    // 递归
    arrayToNode1 (nodesArray, pid) {
      const vm = this
      return nodesArray.filter(value => {
        if (value.upid === pid) {
          const arrayToNode = vm.arrayToNode1(nodesArray, value.id)
          if (arrayToNode.length > 0) {
            value.child = arrayToNode
          }
          return value
        }
      })
    },
    changeType (id) {
      console.log(123, this.st_id)
      console.log(id)
    },
    // 全部服务商
    getAllSupplier () {
      let params = {
        page: 1,
        size: 99999
      }
      querysupplierorgnotype(params).then(res => {
        this.allSupplier = res.data.org
        // this.getAllService()
        this.getTableOrder()
      }).catch(() => {
        this.loading = false
      })
    },
    // 服务单表格数据
    getTableOrder () {
      let params = {
        page: this.currentPage,
        size: this.pageSize
      }
      let data = {
        start_time: this.sendTime ? this.sendTime[0] + ' 00:00:00' : '',
        end_time: this.sendTime ? this.sendTime[1] + ' 23:59:59' : '',
        supplier_ids: this.so_ids,
        is_cycle: this.pssType,
        st_id: this.st_id ? this.st_id : 0,
        supplier_person_name: this.searchKeyword,
        oldperson_name: this.oldperson_name
      }
      querypersonsupplierservice(params, data).then(res => {
        this.tableData = res.data.pss
        this.totalCells = res.data.cnt
        this.loading = false
        // 处理页面跳转过来需要发起服务
        let old = this.store2.state.other.serviceInfo.oldPerson
        console.log('old', this.store2.state.other.serviceInfo)
        if (old !== '') {
          this.addServiceOrderBtn()
        }
      }).catch(() => {
        this.loading = false
      })
    },
    searchQuery () {
      this.currentPage = 1
      this.tableData = []
      this.getTableOrder()
    },
    addServiceOrderBtn () {
      this.titleShow = '发起服务单'
      this.addObj.isAdd = 1
      this.addObj.row = ''
      this.addServiceOrderShow = true
    },
    updateService (row) {
      this.titleShow = '修改服务单'
      this.addObj.isAdd = 2
      this.addObj.row = row
      this.addServiceOrderShow = true
    },
    handleService (row) {
      this.titleShow = '服务单详情'
      this.addObj.isAdd = 3
      this.addObj.row = row
      this.addServiceOrderShow = true
    },
    handleSizeChange (val) {
      this.pageSize = val
      this.getTableOrder()
    },
    handleCurrentChange (val) {
      this.currentPage = val
      this.getTableOrder()
    }
  }
}
</script>

<style scoped>
.blue-tab{
  padding: 0 8px;
  height: 27px;
  line-height: 27px;
  color: #FFFFFF;
  font-size: 16px;
  background: #5A9CF8;
  border-radius: 3px 3px 3px 3px;
  border: none;
}
.purple-tab{
  padding: 0 8px;
  height: 27px;
  line-height: 27px;
  color: #FFFFFF;
  font-size: 16px;
  background: #A45AF8;
  border-radius: 3px 3px 3px 3px;
  border: none;
}
.yellow-tab{
  padding: 0 8px;
  height: 27px;
  line-height: 27px;
  color: #FFFFFF;
  font-size: 16px;
  background: #F89C5A;
  border-radius: 3px 3px 3px 3px;
  border: none;
}
.pink-tab{
  padding: 0 8px;
  height: 27px;
  line-height: 27px;
  color: #FFFFFF;
  font-size: 16px;
  background: #F85A91;
  border-radius: 3px 3px 3px 3px;
  border: none;
}
.green-tab{
  width: 96px;
  padding: 0 8px;
  height: 27px;
  line-height: 27px;
  color: #FFFFFF;
  font-size: 16px;
  background: #6daf38;
  border-radius: 3px 3px 3px 3px;
  border: none;
}
</style>



// WEBPACK FOOTER //
// src/components/datamanagement/serviceSupplierOrder.vue